<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M4.10014 7.13514V18.9459H20.8999V7.13514H4.10014ZM2.00017 6.87838C2.00017 5.88576 2.82284 5.08108 3.83764 5.08108H21.1624C22.1772 5.08108 22.9998 5.88576 22.9998 6.87838V19.2027C22.9998 20.1953 22.1772 21 21.1624 21H3.83764C2.82284 21 2.00017 20.1953 2.00017 19.2027V6.87838Z"
			:fill="color"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M8.28141 2.75202C8.77369 2.27051 9.44136 2 10.1375 2H14.8625C15.5586 2 16.2263 2.27051 16.7186 2.75202C17.2109 3.23354 17.4874 3.88661 17.4874 4.56757V6.10811C17.4874 6.67532 17.0173 7.13514 16.4374 7.13514C15.8575 7.13514 15.3875 6.67532 15.3875 6.10811V4.56757C15.3875 4.43138 15.3321 4.30076 15.2337 4.20446C15.1352 4.10816 15.0017 4.05405 14.8625 4.05405H10.1375C9.9983 4.05405 9.86477 4.10816 9.76631 4.20446C9.66786 4.30076 9.61255 4.43138 9.61255 4.56757V6.10811C9.61255 6.67532 9.14245 7.13514 8.56256 7.13514C7.98268 7.13514 7.51258 6.67532 7.51258 6.10811V4.56757C7.51258 3.88661 7.78914 3.23354 8.28141 2.75202Z"
			:fill="color"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M22.8588 10.8221C23.1491 11.3132 22.9775 11.9414 22.4755 12.2254C19.4439 13.9404 16.0029 14.8416 12.5007 14.8378C8.997 14.8464 5.55378 13.9446 2.52321 12.2246C2.02163 11.94 1.85095 11.3115 2.14198 10.8209C2.433 10.3303 3.07553 10.1633 3.5771 10.448C6.28649 11.9857 9.36485 12.7918 12.4973 12.7838L12.5012 12.7838C15.6341 12.7874 18.7122 11.9814 21.4242 10.4473C21.9262 10.1633 22.5684 10.3311 22.8588 10.8221Z"
			:fill="color"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.2688 10.7297C10.2688 10.1625 10.7389 9.7027 11.3188 9.7027H13.6812C14.2611 9.7027 14.7312 10.1625 14.7312 10.7297C14.7312 11.2969 14.2611 11.7568 13.6812 11.7568H11.3188C10.7389 11.7568 10.2688 11.2969 10.2688 10.7297Z"
			:fill="color"
		/>
	</svg>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: '#597393',
		},
	},
};
</script>
